import { useCallback, useState } from "react";
import { useMediaQuery } from "./useMediaQuery";

const CLAVE = "ads:barra-lateral:plegada";

function leerPlegada(): boolean {
  try {
    return localStorage.getItem(CLAVE) === "1";
  } catch {
    return false;
  }
}

/**
 * Estado de la barra lateral (visual.md §4). Desde 1200 px: 240 px, plegable a 64 px y la preferencia se
 * recuerda. De 600 a 1199 px: carril de 64 px que se despliega a 240 px ENCIMA del contenido.
 */
export function useBarraLateral() {
  const ancho = useMediaQuery("(min-width: 1200px)", true);
  const [plegada, setPlegada] = useState(leerPlegada);
  const [sobrepuesta, setSobrepuesta] = useState(false);

  const alternar = useCallback(() => {
    if (ancho) {
      setPlegada((valor) => {
        try {
          localStorage.setItem(CLAVE, valor ? "0" : "1");
        } catch {
          // La preferencia es opcional.
        }
        return !valor;
      });
    } else {
      setSobrepuesta((valor) => !valor);
    }
  }, [ancho]);

  const cerrarSobrepuesta = useCallback(() => setSobrepuesta(false), []);
  const desplegadaSobre = !ancho && sobrepuesta;

  return {
    /** El hueco que ocupa en la rejilla: siempre carril por debajo de 1200 px. */
    carrilEnRejilla: ancho ? plegada : true,
    /** La barra en sí: solo iconos salvo que esté plegada a propósito o, en pantallas medias, sin desplegar. */
    soloIconos: ancho ? plegada : !sobrepuesta,
    sobrepuesta: desplegadaSobre,
    alternar,
    cerrarSobrepuesta,
  };
}
